<form [formGroup]="workExperienceForm" (ngSubmit)="onSubmit()">
  <div class="form-row form-row--two-columns">
    <app-input
      [label]="'profile.workExperience.employer' | transloco"
      formControlName="employer"
      [errorMessage]="
        workExperienceForm.get('employer')?.invalid && workExperienceForm.get('employer')?.touched ?
        (workExperienceForm.get('employer')?.errors?.['maxlength'] ?
        ('validation.databaseConstraint.employer' | transloco: {max: VALIDATION.EMPLOYER_MAX_LENGTH}) :
        ('profile.errors.employerRequired' | transloco)) : ''
      "
      [required]="true"></app-input>
    <app-input
      [label]="'profile.workExperience.position' | transloco"
      formControlName="position"
      [errorMessage]="
        workExperienceForm.get('position')?.invalid && workExperienceForm.get('position')?.touched ?
        (workExperienceForm.get('position')?.errors?.['maxlength'] ?
        ('validation.databaseConstraint.position' | transloco: {max: VALIDATION.POSITION_MAX_LENGTH}) :
        ('profile.errors.positionRequired' | transloco)) : ''
      "
      [required]="true"></app-input>
  </div>

  <div class="form-row form-row--two-columns">
    <app-input
      [label]="'profile.workExperience.city' | transloco"
      formControlName="city"
      [errorMessage]="
        workExperienceForm.get('city')?.invalid && workExperienceForm.get('city')?.touched ?
        ('validation.maxLength.city' | transloco: {max: VALIDATION.CITY_MAX_LENGTH}) : ''
      "
      [required]="false"></app-input>
    <app-input
      [label]="'profile.workExperience.country' | transloco"
      formControlName="country"
      [errorMessage]="
        workExperienceForm.get('country')?.invalid && workExperienceForm.get('country')?.touched ?
        ('validation.maxLength.country' | transloco: {max: VALIDATION.COUNTRY_MAX_LENGTH}) : ''
      "
      [required]="false"></app-input>
  </div>

  <div class="form-row form-row--two-columns">
    <app-input
      [label]="'profile.workExperience.startDate' | transloco"
      type="date"
      formControlName="startDate"
      [errorMessage]="
        workExperienceForm.get('startDate')?.invalid && workExperienceForm.get('startDate')?.touched ? ('profile.errors.startDateRequired' | transloco) : ''
      "
      [required]="true"></app-input>

    <div class="date-input-container">
      <app-input
        [label]="'profile.workExperience.endDate' | transloco"
        type="date"
        formControlName="endDate"
        [errorMessage]="
          workExperienceForm.get('endDate')?.invalid && workExperienceForm.get('endDate')?.touched
            ? ('profile.errors.endDateRequired' | transloco)
            : (workExperienceForm.errors?.['dateRange'] && workExperienceForm.get('endDate')?.touched
              ? ('profile.validation.endBeforeStart' | transloco)
              : '')
        "
        [required]="true"></app-input>

      <div class="currently-working-checkbox">
        <input type="checkbox" id="isCurrentlyWorking" formControlName="isCurrentlyWorking" (change)="onCurrentlyWorkingChange($event)" />
        <label for="isCurrentlyWorking">{{ 'profile.workExperience.currentlyWorking' | transloco }}</label>
      </div>
    </div>
  </div>

  <!-- Description field with rich text editor -->
  <div class="form-row">
    <div class="rich-text-content">
      <label>{{ 'profile.workExperience.description' | transloco }}</label>
      <div>
        <div class="">
          <div class="NgxEditor__Wrapper">
            <ngx-editor-menu [editor]="descriptionEditor" [toolbar]="toolbar"></ngx-editor-menu>
            <ngx-editor
              [editor]="descriptionEditor"
              [(ngModel)]="htmlDescription"
              formControlName="description"
              [disabled]="false"
              [placeholder]="'profile.workExperience.descriptionPlaceholder' | transloco">
            </ngx-editor>
          </div>
        </div>
      </div>
      <div *ngIf="workExperienceForm.get('description')?.invalid && workExperienceForm.get('description')?.touched" class="error-message">
        <span *ngIf="workExperienceForm.get('description')?.errors?.['maxlength']">
          {{ 'validation.databaseConstraint.description' | transloco: {max: VALIDATION.DESCRIPTION_MAX_LENGTH} }}
        </span>
      </div>
    </div>
  </div>

  <div class="form-actions">
    <app-button type="button" variant="outline" color="secondary" (click)="cancel.emit()">
      {{ 'button.cancel' | transloco }}
    </app-button>
    <app-button type="submit" variant="filled" [disabled]="workExperienceForm.invalid">
      {{ 'button.save' | transloco }}
    </app-button>
  </div>
</form>
